
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgImageMapa = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2.75,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.094 9.507a11.897 11.897 0 0 1 8.399 8.4m-9.629-3.81a7.138 7.138 0 0 1 5.04 5.039",
  stroke: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.571 22.107a13.777 13.777 0 0 0 6.379 6.35c.413.195.899.159 1.278-.097l4.09-2.727a1.307 1.307 0 0 1 1.239-.114l7.65 3.279c.534.226.853.779.784 1.355A7.841 7.841 0 0 1 29.213 37C16.945 37 7 27.055 7 14.787a7.841 7.841 0 0 1 6.847-7.778c.576-.07 1.129.25 1.355.784l3.282 7.657c.172.402.132.864-.108 1.23l-2.717 4.152c-.252.38-.285.864-.088 1.275z",
  stroke: "#000"
}))));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g stroke-width=\"2.75\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <path d=\"M26.094 9.507a11.897 11.897 0 0 1 8.399 8.4M24.864 14.097a7.138 7.138 0 0 1 5.04 5.039\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n        <path d=\"M15.571 22.107a13.777 13.777 0 0 0 6.379 6.35c.413.195.899.159 1.278-.097l4.09-2.727a1.307 1.307 0 0 1 1.239-.114l7.65 3.279c.534.226.853.779.784 1.355A7.841 7.841 0 0 1 29.213 37C16.945 37 7 27.055 7 14.787a7.841 7.841 0 0 1 6.847-7.778c.576-.07 1.129.25 1.355.784l3.282 7.657c.172.402.132.864-.108 1.23l-2.717 4.152c-.252.38-.285.864-.088 1.275z\" stroke=\"#000\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/image-mapa.855b15867e3664222e45d894ebb5886b.svg"),
        {
          React: SvgImageMapa,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      